import { useMemo } from 'react';
import useSelectedTheme from '@rsos/hooks/useSelectedTheme';
import { LIGHT_THEME } from '@rsos/theme/constants';
import {
  ALERTS,
  ALERTS_DARK,
  TF911_LIGHT,
  TF911_DARK,
  RCS911_LIGHT,
  RCS911_DARK,
  TCAPI_LIGHT,
  TCAPI_DARK,
  INTERAGENCY_DARK,
  INTERAGENCY_LIGHT,
} from '../constants/talkjsThemes';

type ChatType = 'tf911' | 'rcs' | 'tcapi' | 'alerts' | 'interagency';

const THEME_MAP: Record<ChatType, Record<string, string>> = {
  rcs: { light: RCS911_LIGHT, dark: RCS911_DARK },
  tf911: { light: TF911_LIGHT, dark: TF911_DARK },
  tcapi: { light: TCAPI_LIGHT, dark: TCAPI_DARK },
  alerts: { light: ALERTS, dark: ALERTS_DARK },
  interagency: { light: INTERAGENCY_LIGHT, dark: INTERAGENCY_DARK },
};

/**
 * Get the TalkJS UI theme that corresponds to the Portal theme.
 */
const useTalkJSTheme = (chatType: ChatType = 'alerts') => {
  const themeName = useSelectedTheme();
  return useMemo(() => {
    const themeVariant = themeName === LIGHT_THEME ? 'light' : 'dark';
    return THEME_MAP[chatType][themeVariant];
  }, [chatType, themeName]);
};

export default useTalkJSTheme;
